import { render, staticRenderFns } from "./memberUnitDetail.vue?vue&type=template&id=49f53120&scoped=true&"
import script from "./memberUnitDetail.vue?vue&type=script&lang=js&"
export * from "./memberUnitDetail.vue?vue&type=script&lang=js&"
import style0 from "./memberUnitDetail.vue?vue&type=style&index=0&id=49f53120&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f53120",
  null
  
)

export default component.exports